import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChamadoFranquiaRoutingModule } from './chamado-franquia-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ChamadoFranquiaRoutingModule
  ]
})
export class ChamadoFranquiaModule { }
